export default function LoadingBear({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <div className="text-4xl animate-bear-pulse">🐻</div>
      <p className="text-mm-parchment/50 text-xs tracking-wide">{message}</p>
    </div>
  )
}
